<template>
  <div class="c-app flex-row align-items-center">
    <!--***************************************Toast**************************************-->
        <div style="position:fixed;right:100px;top:50px;z-index: 100000;" v>
            <div v-for="(toast,index ) in $store.state.Toasts" v-bind:key="index+500">
                <p v-if="toast.MessageType==='success'" variant="solid" style="background-color:green;color:white;font-size: 14px;padding: 10px;border-radius: 7px;">{{toast.Message}}</p>
                <p  v-else-if="toast.MessageType==='error'" variant="solid" style="background-color:red;color:white;font-size: 14px;padding: 10px;border-radius: 7px;">{{toast.Message}}</p>
            </div>
        </div>


    <CContainer>
      <CRow class="justify-content-center">
        <CCol md="4">
          <CCardGroup >
            <CCard class="p-4" id="Log" >
              <CCardBody>
                <CForm>
                  <h1>ورود</h1>
                  <p class="text-muted">ورود کاربر</p>
                  <CInput
                    placeholder="نام کاربری"
                    autocomplete="username email"
                    v-model="UserName"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="کلمه عبور"
                    type="password"
                    autocomplete="curent-password"
                    v-model="Password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CRow>
                    <div style="margin:0 auto;direction:rtl">
                        <img ref="captcha" width="150px" height="80px" :src="BaseCaptcha" alt="" style="width:200px;height:80px;" >   
                        <img src="/images/refresh.gif" style="width:30px;height:30px;margin-right:20px;cursor:pointer" alt="" @click="imageRefresh()">
                    </div>
                    
                    <br>
                    <input class="txt-Sequrity"  type="text" placeholder=" ... کد امنیتی را وارد نمایید" v-model="Captcha" style="margin-bottom:30px;height:40px;margin-top: 10px;"/>
                    
                  </CRow>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton color="primary" class="px-4" @click="Login">ورود</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0">رمز عبور را فراموش کرده ام؟</CButton>
                      <CButton color="link" class="d-lg-none">ثبت نام کنید!</CButton>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <!-- <CCard
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
              style="background: #321FDB"
              id="Register"
              v-if="false"
            >
              <CCardBody style="background: unset">
                <h2>ثبت نام</h2>
                <p style="color: white;font-size: 16px">کاربر گرامی جهت استفاده از این سامانه ابتدا باید ثبت نام کنید اگر تاکنون ثبت نام نکرده اید روی ثبت نام کلیک کنید.

                  </p>
                <br>
                <p style="color: white;font-size: 16px">
                  Dear user, in order to use this system, you must first register. If you have not registered yet, click on Register.
                </p>
                <CButton
                  color="light"
                  variant="outline"
                  
                  size="lg"
                >
                  حالا ثبت نام کنید!
                </CButton>
              </CCardBody>
            </CCard> -->
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Constant from './../../assets/Constants'
Vue.use(VueAxios, axios);

export default {
  name: 'Login',
  data(){
    return {
          UserName:'',
          Password:'',
          Captcha:'',
          BaseCaptcha:'',
    }
  },
  computed:{
      ReadUsers_Login(){
        return this.$store.state.Users_Login;
      }
  },
  watch:{
    ReadUsers_Login(data){
            if(data.Status!==undefined){
              if(data.Status){
                  if(data.RequestResponse[0].LOGIN==='OK'){
                    if(data.token){
                        localStorage.setItem('token', data.token)
                      }
                      this.$session.set("User",data.Data_1[0]);
                      this.$session.set("Permission",data.Data_2[0]);
                      window.open("/#/", "_self");
                      
                    }
                    else if(data.RequestResponse[0].LOGIN==='CAPTCHA'){
                      this.$store.commit('ShowToast',{type:'error',message:'لطفا کد امنیتی معتبر وارد نمایید'})
                      
                    }
                    else if(data.RequestResponse[0].LOGIN==='NO' || data.RequestResponse[0].LOGIN==='NOK'){
                      this.$store.commit('ShowToast',{type:'error',message:'لطفا نام کاربری و کلمه عبور معتبر وارد نمایید'})
                      
                  }
                    else if(data.RequestResponse[0].LOGIN==='LOK'){
                      this.$store.commit('ShowToast',{type:'error',message:'اطلاعات کاربری شما به دلیل مسائل امنیتی مسدود شده است'})
                    
                  }
                this.imageRefresh();
              }
            }
             
        }
  },
  mounted() {
    
    this.BaseCaptcha=Constant.Captcha;
    this.GetFleets();

  },
  methods:{
    Login(){
      var crypto = require('crypto')
      var shasum = crypto.createHash('sha1')
      shasum.update(this.Password)
      var pass=shasum.digest('hex');
      this.$store.commit('Users_Login',{
        UserName:this.UserName.toLocaleLowerCase(),
        Password:pass.toUpperCase(),
        Captcha:this.Captcha,
      });  
    },
    GetFleets(){
        this.$store.commit('Session');
    },
    imageRefresh() {
      var that=this;
      this.$refs.captcha.src=that.BaseCaptcha
  }
  }
}
</script>
<style>
.txt-Sequrity{
  border: 1px solid #6fa3f9;
  border-radius: 7px;
  font-size: 12px;
}
.txt-Sequrity:focus{
  outline: 0;
}
 /* #Reg .card-body {
    background: #321FDB;

  }*/
   #Log img{
    max-width: 100%;
  }
 /* #Log button{
    color: white;
    text-decoration: none;
  }
  .text-muted{
    color: white;
  } */
</style>
